import React, { useState, useEffect } from "react";

import styles from "../index.module.css";

function ListItem(props) {
  const {
    player: { rank, screenName, maxNumBets, numBets, score, scoreDate }
  } = props;

  const [activated, setActivated] = useState(false);
  const now = new Date();
  const isNew =
    (Date.parse(now.toUTCString()) - Date.parse(scoreDate)) / 1000 < 5;

  const formattedNumBets =
    maxNumBets === 99999 ? numBets : (maxNumBets || 0) - (numBets || 0);

  useEffect(() => {
    if (isNew) {
      setActivated(true);
    } else {
      setActivated(false);
    }
  }, [isNew]);
  return (
    <div
      className={`${styles.highscoreItem} ${
        rank === 1 ? styles.rankOne : null
      } ${activated ? styles.active : null}`}
    >
      <div className={`${styles.highscoreRank}`}>
        {rank}
      </div>
      <div className={styles.highscoreName}>{screenName}</div>
      {formattedNumBets > 0 ? (
        <div
          className={styles.highscoreSpin}
          align="middle
      "
        >
          {formattedNumBets}
        </div>
      ) : null}

      <div className={styles.highscoreScore}>{score}</div>
    </div>
  );
}
export default ListItem;
